// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__19V-7","label":"Radio_label__khivV","checkMark":"Radio_checkMark__1r1ce","disabled":"Radio_disabled__3UpcA"};